import useScroll from "../../hooks/useScroll";
import { templates } from "../../utilities/objects/template";
import ResponsiveImage from "../common/ResponsiveImage";

interface SectionFeatureTemplateProps {
  title?: string;
  description?: string;
}

const SectionFeatureTemplate: React.FC<SectionFeatureTemplateProps> = ({
  title = "Nền tảng mới cập nhật",
  description = "Bộ mẫu được tuyển chọn để doanh nghiệp có thể triển khai nhanh website, landing page, dashboard hoặc mobile UI theo mục tiêu vận hành và tăng trưởng.",
}) => {
  const featuredTemplates = templates.slice(0, 8);
  const { scrollRef, handleMouseEnter, handleMouseLeave } = useScroll();

  return (
    <section className="w-full bg-gradient-to-b from-white to-[#fff8f8] py-12">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="mb-10 max-w-[760px]">
          <p className="text-left text-[26px] font-semibold leading-[1.2] text-[#2f1a1a] sm:text-[30px]">
            {title}
          </p>
          <p className="mt-3 text-left text-[15px] leading-8 text-slate-600">{description}</p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {featuredTemplates.map((tpl) => (
            <article
              key={tpl.id}
              className="overflow-hidden rounded-[22px] border border-red-100 bg-white shadow-[0_14px_34px_rgba(127,29,29,0.05)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_44px_rgba(127,29,29,0.08)]"
            >
              <div
                className="hide-scrollbar relative h-[220px] overflow-y-auto overflow-x-hidden"
                ref={(el) => {
                  scrollRef.current[tpl.id] = el;
                }}
                onMouseEnter={() => handleMouseEnter(tpl.id)}
                onMouseLeave={() => handleMouseLeave(tpl.id)}
              >
                <ResponsiveImage src={tpl.img} alt={tpl.name} className="w-full select-none" />
              </div>

              <div className="p-4">
                <span className="inline-flex rounded-full border border-red-100 bg-red-50 px-2.5 py-1 text-[11px] font-medium text-red-700">
                  {tpl.industry}
                </span>

                <p className="mt-3 text-[16px] font-semibold leading-6 text-[#2f1a1a]">{tpl.title}</p>

                <ul className="mt-4 space-y-2 text-left">
                  {tpl.highlights?.slice(0, 2).map((item) => (
                    <li key={item} className="flex items-start gap-2 text-[12.5px] leading-6 text-slate-600">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-red-500" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectionFeatureTemplate;
